<div class="signature-wrapper">
  <div class="signature-header">
    <button
      type="button"
      class="clear-button"
      (click)="clearSignature()"
      [disabled]="!hasSignature"
    >
      <mat-icon>replay</mat-icon>
      <span>{{ "Redosignature" | translate }}</span>
    </button>
  </div>

  <div #signatureContainer class="signature-container">
    <div class="signature-x">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </div>
    <div class="signature-line">
      <hr />
    </div>
    <signature-pad
      #signature
      [options]="signaturePadOptions"
      (drawStart)="drawStart($event)"
      (drawEnd)="drawComplete($event)"
    ></signature-pad>
  </div>

  <p *ngIf="inkGuardError" class="signature-ink-error">{{ inkGuardError | translate }}</p>
</div>
